import I18n from "common/i18n";
import { LatestLayout } from "features/creator/tutorial/top/stages/Layout";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { next, close } = props;
  return (
    <LatestLayout next={next} close={close}>
      <div className="flex-row-el items-center justify-start w-full p-0 gap-3">
        <div className="flex-col-el flex-center bg-orange-100 rounded-full border-solid border-[4px] border-orange-100 px-1 w-[32px] h-[32px]">
          <p className="text-body text-[22px] text-white leading-[48px]">3</p>
        </div>

        <div className="flex-row-el flex-center px-2 bg-blue-100 rounded-[8px]">
          <p className="text-body text-[14px] leading-6 text-white">
            {I18n.t("MSG_CREATOR_APP_SHARED_APPS")}
          </p>
        </div>
      </div>
    </LatestLayout>
  );
};

export default Step;
